import type { FC } from 'react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LinkStyled } from '@components/atoms/link/styles';
import type { LinkProps } from '@components/atoms/link/types';
import cn from 'classnames';
import { styled } from 'styled-components';

const Atom: FC<LinkProps> = ({ href, to, dashed, className, ...rest }) => {
    if (to) {
        return (
            <LinkStyled as={RouterLink} className={cn({ dashed }, className)} to={to} {...rest} />
        );
    }

    if (href) {
        return <LinkStyled href={href} className={cn({ dashed }, className)} {...rest} />;
    }

    return <LinkStyled className={cn({ dashed }, className)} {...rest} />;
};

export const Link = styled(Atom)({});
